<div class="bundle-time-meter">
  <div class="d-flex">
    <div class="w-full">
      <div class="today-indicator d-flex w-full">
        <div [ngStyle]="{ width: 'calc(' + bundleTimeProgress + '% - 5px)' }"></div>
        <div>
          <div [class.text-right]="bundleTimeProgress > 87">
            <span class="t-12 text-muted">Today, {{ bundleDaysLeft }} days left</span>
          </div>
          @if (bundleTimeProgress < 88) {
            <div class="indicator"><fa-icon icon="chevron-down"></fa-icon></div>
          }
        </div>
      </div>
    </div>
    <div style="width: 35px"></div>
  </div>
  <div class="meter-container">
    <div class="meter">
      <div
        class="total-used"
        [class.warning]="!userService.subDetails?.stripe_subscription && !userService.subDetails?.scheduled_stripe_subscription && bundleTimeProgress > 66 && bundleTimeProgress < 85"
        [class.danger]="!userService.subDetails?.stripe_subscription && !userService.subDetails?.scheduled_stripe_subscription && bundleTimeProgress > 84"
        placement="top"
        [ngStyle]="{ width: bundleTimeProgress + '%' }"
      ></div>
    </div>
    <div
      class="meter-end"
      [class.canceling]="!userService.subDetails?.scheduled_stripe_subscription && !userService.subDetails?.stripe_subscription"
      [class.scheduled]="userService.subDetails?.scheduled_stripe_subscription || userService.subDetails?.stripe_subscription"
      [ngbTooltip]="userService.subDetails?.scheduled_stripe_subscription || userService.subDetails?.stripe_subscription ? 'Your plan will continue.' : 'Your subscription will end!'"
    >
      <fa-icon [icon]="!userService.subDetails?.scheduled_stripe_subscription && !userService.subDetails?.stripe_subscription ? 'times' : 'check'"></fa-icon>
      <span class="sr-only">
        {{ userService.subDetails?.scheduled_stripe_subscription || userService.subDetails?.stripe_subscription ? "Your plan will continue." : "Your subscription will end!" }}
      </span>
    </div>
  </div>
  <div class="d-flex justify-content-between m-t-10">
    <div class="t-12 start-end-note">
      <span class="brandfont-black">
        {{ "account.started_on" | translate: { startDate: (userService.subDetails.stripe_subscription?.discount?.start * 1000 || userService.subDetails.subscription.start_date | date: "M/D/y") } }}
      </span>
    </div>
    <div class="t-12 start-end-note">
      @if (userService.subDetails.subscription_status == "monthly_active_coupon") {
        <span class="brandfont-black">
          {{ "account.next_paid_invoice" | translate: { nextInvoiceDate: realDiscountEnd | date: "M/D/y" } }}
        </span>
      }
      @if (userService.subDetails.subscription_status != "monthly_active_coupon") {
        <span class="brandfont-black">
          {{
            "account.next_invoice_or_ends"
              | translate
                : {
                    nextInvoiceOrEnds: userService.subDetails?.scheduled_stripe_subscription || userService.subDetails?.stripe_subscription ? "Next Invoice" : "Ends",
                    endDate: userService.subDetails.subscription.end_date | date: "M/D/y",
                  }
          }}
        </span>
      }
    </div>
  </div>
</div>
